/**
 * AgencyLogo – Einheitlicher Agenturname als visuelles Rechteck.
 * WERBEAGENTUR (schwarz, oben) und LARISSA GIRENKO (bordeaux, unten)
 * haben durch mathematisch berechnete letter-spacings exakt gleiche Breite.
 *
 * Berechnung mit Bebas Neue Zeichenbreiten:
 * WERBEAGENTUR (12 Zeichen): natural 6.66em → mit ls=0.153em → 8.50em
 * LARISSA GIRENKO (15 Zeichen): natural 7.30em → mit ls=0.08em → 8.50em
 * → Beide Zeilen exakt gleich breit = visuelles Rechteck
 *
 * Verwendung:
 *   <AgencyLogo />                  → Standard (Navbar-Größe)
 *   <AgencyLogo size="lg" />        → Groß (Footer, Hero)
 *   <AgencyLogo size="sm" />        → Klein
 *   <AgencyLogo withLogo />         → Mit Logo-Bild links
 *   <AgencyLogo color="light" />    → Für dunkle Hintergründe (weiß/hellrot)
 */

const LOGO_URL = "/manus-storage/logo_2d439bd1.jpg";

interface AgencyLogoProps {
  size?: "sm" | "md" | "lg";
  withLogo?: boolean;
  /** "dark" = schwarzer/bordeaux Text (Standard), "light" = weiß/hellrot für dunkle Hintergründe */
  color?: "dark" | "light";
  className?: string;
}

const SIZE_CONFIG = {
  sm: { fontSize: "9px",  logoSize: 28, gap: "0.4rem" },
  md: { fontSize: "11px", logoSize: 44, gap: "0.6rem" },
  lg: { fontSize: "14px", logoSize: 56, gap: "0.75rem" },
};

export function AgencyLogo({ size = "md", withLogo = false, color = "dark", className = "" }: AgencyLogoProps) {
  const cfg = SIZE_CONFIG[size];
  const topColor = color === "light" ? "#ffffff" : "#000000";
  const bottomColor = color === "light" ? "#ff6666" : "#6d0000";

  return (
    <span
      className={className}
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: cfg.gap,
        textDecoration: "none",
      }}
    >
      {withLogo && (
        <img
          src={LOGO_URL}
          alt="WERBEAGENTUR Larissa Girenko Logo"
          style={{
            width: cfg.logoSize,
            height: cfg.logoSize,
            objectFit: "contain",
            borderRadius: "50%",
            flexShrink: 0,
          }}
        />
      )}
      {/* Rechteck-Textblock: beide Zeilen gleich breit durch mathematisch berechnetes letter-spacing
          WERBEAGENTUR: 12 Zeichen × ls=0.153em → 8.50em Gesamtbreite
          LARISSA GIRENKO: 15 Zeichen × ls=0.08em → 8.50em Gesamtbreite */}
      <span style={{ display: "inline-flex", flexDirection: "column", alignItems: "flex-start" }}>
        <span
          style={{
            fontFamily: "'Bebas Neue', sans-serif",
            color: topColor,
            fontSize: cfg.fontSize,
            lineHeight: 1.1,
            letterSpacing: "0.153em",
            fontWeight: 900,
            textTransform: "uppercase",
            whiteSpace: "nowrap",
            display: "block",
          }}
        >
          WERBEAGENTUR
        </span>
        <span
          style={{
            fontFamily: "'Bebas Neue', sans-serif",
            color: bottomColor,
            fontSize: cfg.fontSize,
            lineHeight: 1.1,
            letterSpacing: "0.08em",
            fontWeight: 900,
            textTransform: "uppercase",
            whiteSpace: "nowrap",
            display: "block",
          }}
        >
          LARISSA GIRENKO
        </span>
      </span>
    </span>
  );
}
